/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import * as actionTypes from './actionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';

export const setSelectedClient = (data) => {
  return {
    type: 'SET_SELECTED_CLIENT',
    payload: data,
  };
};

export const setInvoiceNumber = (data) => {
  return {
    type: 'SET_INVOICE_NUMBER',
    payload: data,
  };
};

export const setFreezeInvoiceData = (data) => {
  return {
    type: actionTypes.SET_REQ_RECORD_MAILING_DATA,
    payload: data,
  };
};

export const resetFreezeInvoiceStore = () => {
  return {
    type: actionTypes.RESET_FREEZEINVOICE_STORE_FREEZE_INV,
  };
};

export const dispatchManufacturersByPQR = (data) => {
  return {
    type: actionTypes.GET_MANUFACTURERS_BY_PQR,
    payload: data,
  };
};

export const getManufacturersByPQR = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_MANUFACTURERS_BY_PQR, values)
    .then((response) => {
      return dispatch(dispatchManufacturersByPQR(response.data));
    })
    .catch((response) => {
      dispatch(dispatchManufacturersByPQR(response.date));
    });
};

export const getManufacturersForFreezeInv = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_MANUFACTURERS_FOR_FREEZE_INV, values)
    .then((response) => {
      return dispatch(dispatchManufacturersByPQR(response.data));
    })
    .catch((response) => {
      dispatch(dispatchManufacturersByPQR(response.date));
    });
};

export const dispatchFreezeInvoiceSaveRes = (data) => {
  return {
    type: actionTypes.INVOICE_FREEZE_RES,
    payload: data,
  };
};

export const freezeInvoice = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.FREEZE_INVOICE, values)
    .then((response) => {
      return dispatch(dispatchFreezeInvoiceSaveRes(response.data));
    })
    .catch(() => {
      dispatch(dispatchFreezeInvoiceSaveRes({ error: 'API failed' }));
    });
};

export const setDefaultQtr = (data) => {
  return {
    type: actionTypes.SET_DEFAULT_QTR,
    defaultQtrFreezeInv: data,
  };
};

export const setErrorMessages = (data) => {
  return {
    type: actionTypes.SET_ERROR_MSG,
    errorMsgsStore: data,
  };
};

export const getMaxQuarterForFreezeDt = () => (dispatch) => {
  return axios
    .get(`${serviceEndPoint.GET_MAXQUARTER_PLUS_ONE}`)
    .then((response) => {
      return dispatch(setDefaultQtr(response.data));
    })
    .catch((response) => {
      dispatch(setDefaultQtr(response.date));
    });
};
